import { jsx as b } from "react/jsx-runtime";
import { Combobox as f } from "@headlessui/react";
function p({
  children: r,
  selectedData: e,
  virtual: i,
  disabled: n,
  onClose: m,
  onChange: u
}) {
  return /* @__PURE__ */ b(
    f,
    {
      immediate: !0,
      value: e,
      virtual: i,
      onChange: (o) => {
        o !== null && u(o == null ? void 0 : o.id);
      },
      disabled: n,
      onClose: m,
      children: ({ open: o }) => r(o)
    }
  );
}
export {
  p as ComboboxSinge
};
